import { OnInit } from "@angular/core";
import * as ThumborUrlBuilder from "thumbor-url-builder";
import { Field } from '../../models/field.model';
export class FormProfileimageUploadComponent extends Field {
    constructor() {
        super(...arguments);
        /**
         * Attributes
         */
        this.BOO_image_loaded = false;
        this.BOO_image_edit = false;
        this.STR_url = null;
    }
    /**
     * Lifecycle > ngOnInit
     */
    ngOnInit() {
        // image upload allowed
        if (this.OBJ_field_config.readonly != null && this.OBJ_field_config.readonly == false) {
            this.BOO_image_edit = true;
        } // end if
        // image exists
        if (this.OBJ_field_config.value != null) {
            this.BOO_image_loaded = true;
            this.OBJ_thumbor_url_builder = new ThumborUrlBuilder("infinity", this.OBJ_field_config.domain);
            this.STR_url = this.OBJ_thumbor_url_builder
                .setImagePath(this.OBJ_field_config.value)
                .resize(150, 150)
                .smartCrop(true)
                .buildUrl();
        } // end if
    } // end lifecycle ngOnInit
    /**
     * Function > fileChangeListener
     * @param $OBJ_event
     */
    fileChangeListener($OBJ_event) {
        let OBJ_file = $OBJ_event.dataTransfer ? $OBJ_event.dataTransfer.files[0] : $OBJ_event.target.files[0];
        let STR_allowed_files = /.(jpe?g|png|gif)$/i;
        let OBJ_file_reader = new FileReader();
        let OBJ_form_control = this.OBJ_form_group.get("image");
        if (OBJ_file != null && !OBJ_file.type.match(STR_allowed_files)) {
            // set error
            OBJ_form_control.setErrors({ "invalidFormat": true });
            // reset config
            this.OBJ_field_config.value = null;
            this.BOO_image_loaded = false;
            this.STR_url = null;
            // abort
            return;
        }
        else {
            OBJ_form_control.setErrors(null);
        } // end if
        OBJ_file_reader.onloadend = (OBJ_load_event) => {
            this.OBJ_field_config.value = OBJ_file_reader.result;
            this.STR_url = OBJ_file_reader.result;
            this.BOO_image_loaded = true;
        };
        if (OBJ_file != null) {
            OBJ_file_reader.readAsDataURL(OBJ_file);
        } // end if
        this.markAsDirtyAndTouched();
    } // end function fileChangeListener
    /**
     * Function > reset
     */
    reset() {
        this.OBJ_field_config.value = null;
        this.BOO_image_loaded = false;
        this.OBJ_form_group.get("image").setErrors(null);
        // set FormControl to dirty
        this.markAsDirtyAndTouched();
    } // end function reset
    /**
     * Function > onDrop
     * @param $OBJ_event
     */
    onDrop($OBJ_event) {
        $OBJ_event.preventDefault();
        this.fileChangeListener($OBJ_event);
    } // end function onDrop
    /**
     * Function > onDragOver
     * @param $OBJ_event
     */
    onDragOver($OBJ_event) {
        $OBJ_event.stopPropagation();
        $OBJ_event.preventDefault();
    } // end function onDragOver
} // end class FormFileUploadComponent
